import React, { useEffect } from 'react';
import scrollToComponent    from 'react-scroll-to-component';
import PricingTOC           from './PricingTOC';
import PricingJumpTo        from './PricingJumpTo';
import servicesPricing      from 'pursuit/config/servicesPricing';

export default function Pricing(props) {
    const { scrollTo } = props;

    const scrollReferences = [];

    useEffect(() => {
        if (scrollTo !== 'undefined') {
            scrollToComponent(
                scrollReferences[scrollTo], {
                    offset: -100,
                    align: 'top',
                    duration: 300,
                }
            );
        }
    }, []);

    return (
        <section role="main" className="pricing">
            <div className="grid-center pricing">
                <div className="col-0_xs-12_sm-12_lg-0 justify-center">
                    <PricingJumpTo
                        scrollReferences={scrollReferences}
                    />
                </div>
                <div className="col-8_xs-12_sm-12_md-12">
                    <p className="justify-center">* Small pricing increases on select services as of June 2nd 2020</p>
            {Object.keys(servicesPricing).map((serviceType, key) => {
                return (
                    <section key={key}>
                        <h2
                            className="content-title justify-center minor-margin--bottom"
                            dangerouslySetInnerHTML={{__html: serviceType}}
                            ref={(ref) => { scrollReferences[serviceType] = ref; }}
                        />
                        {Object.keys(servicesPricing[serviceType]).map((section, key) => {
                            return (
                                <article key={key}>
                                    <div className="grid-center">
                                        <div className="col-11 section-title text-large highlight">
                                            {section}
                                        </div>
                                    </div>
                                    <div className="grid-center">
                                        <div className="col-11">
                                            {servicesPricing[serviceType][section].map((service, key) => {
                                                return (
                                                    <div
                                                        key={key}
                                                        className={'grid pricing-row minor-margin--bottom'+(service.highlighted ? ' highlighted' : '')}
                                                        ref={(ref) => { scrollReferences[service.slug] = ref; }}
                                                    >
                                                        <div className="col-9_xs-12">
                                                            <Title service={service} />
                                                        </div>
                                                        <div
                                                            className="col-3_xs-12 text-large justify-right bold"
                                                            dangerouslySetInnerHTML={{__html: service.cost}}
                                                        />

                                                        <Hst service={service} />
                                                        <Addons service={service} />

                                                        <div
                                                            className="col-10_xs-12 description-row minor-padding--left"
                                                            dangerouslySetInnerHTML={{__html: service.description}}
                                                        />
                                                        <div className="col-2_xs-12 justify-right description-row">
                                                            <a
                                                                href={service.bookingLink}
                                                                target="_blank"
                                                                className="link cta"
                                                            >
                                                                {typeof service.bookingLabel !== 'undefined' ?
                                                                    service.bookingLabel :
                                                                    'Book Now'}
                                                            </a>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </article>
                            )
                        })}
                    </section>
                )
            })}
                </div>
                <div className="col-4_xs-0_sm-0_md-0">
                    <div className="grid-center">
                        <div className="col-11">
                            <h2 className="content-title minor-margin--bottom">
                                Quick Links
                            </h2>
                            <PricingTOC
                                scrollReferences={scrollReferences}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

const Title = (props) => {
    const { service } = props;

    let duration = '';

    const title = <span
        className="lowlight"
        dangerouslySetInnerHTML={{__html: service.label}}
    />

    if (service.duration != '') {
        duration = <span className="text-tiny lowlight">({service.duration})</span>
    }

    return (
        <div>{title} {duration}</div>
    )
}

const Hst = (props) => {
    const { service } = props;

    if (service.hst === false) {
        return null;
    }

    return (
        <div className="col-11 text-small sub-row justify-right bold" data-push-left="off-1">
            + HST
        </div>
    )
}

const Addons = (props) => {
    const { service } = props;

    if (typeof service.addOns === 'undefined' ||
        service.addOns.length === 0
    ) {
        return null;
    }

    return(
        <div className="col-11 text-small sub-row-container" data-push-left="off-1">
            {service.addOns.map((addOn, key) => {
                return (
                    <div key={key} className="grid">
                        <div className="col-6 text-small sub-row">
                            {addOn.label}
                        </div>
                        <div className="col-6 text-small sub-row justify-right bold">
                            {addOn.cost}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
